// extracted by mini-css-extract-plugin
module.exports = {"text":"consent-banner_text_1Ln-9","banner":"consent-banner_banner_zBJfT","link":"consent-banner_link_8pqpr","aboveSmartBanner":"consent-banner_aboveSmartBanner_3A2Xc"};